import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  projectList,
  fetchQuarterly,
  calculateQuarterly,
  submitQuarterly,
  quarterlyView,
  projectListManager,
  estimate,
  financialYear,
  quarter,
  viewProject,
  quarterManager,
} from './api';
import { message } from 'antd';

const initialState = {
  loading: false,
  projectListData: [],
  quarterlyData: [],
  quarterlyViewData: [],
  projectListManagerData: [],
  financialYear: [],
  quarter: [],
  getViewProjectLoading: false,
  getViewProjectData: null,
};

const actions = {
  PROJECT_LIST: 'PROJECT_LIST',
  FETCH_QUARTERLY: 'FETCH_QUARTERLY',
  CALCULATE_QUARTERLY: 'CALCULATE_QUARTERLY',
  SUBMIT_QUARTERLY: 'SUBMIT_QUARTERLY',
  QUARTERLY_VIEW: 'QUARTERLY_VIEW',
  PROJECT_LIST_MANAGER: 'PROJECT_LIST_MANAGER',
  FETCH_ESTIMATE: 'FETCH_ESTIMATE',
  GET_FINANCIAL_YEAR: 'GET_FINANCIAL_YEAR',
  GET_QUARTER: 'GET_QUARTER',
  GET_QUARTER_MANAGER: 'GET_QUARTER_MANAGER',
  VIEW_PROJECT: 'VIEW_PROJECT',
};

export const getProjectList = createAsyncThunk(
  actions.PROJECT_LIST,
  async (payload) => {
    const response = await projectList(payload);
    return response;
  },
);

export const getViewProject = createAsyncThunk(
  actions.VIEW_PROJECT,
  async ({ projectCode }, thunkAPI) => {
    try {
      const response = await viewProject(projectCode); // Pass only the projectCode
      return response; // Ensure response data is returned
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getFetchQuarterly = createAsyncThunk(
  actions.FETCH_QUARTERLY,
  async (payload) => {
    const response = await fetchQuarterly(payload);
    return response;
  },
);

export const createCalculateQuarterly = createAsyncThunk(
  actions.CALCULATE_QUARTERLY,
  async (payload) => {
    const response = await calculateQuarterly(payload);
    return response;
  },
);

export const createSubmitQuarterly = createAsyncThunk(
  actions.SUBMIT_QUARTERLY,
  async (payload) => {
    const response = await submitQuarterly(payload);
    return response;
  },
);

export const getQuarterlyView = createAsyncThunk(
  actions.QUARTERLY_VIEW,
  async (payload) => {
    const response = await quarterlyView(payload);
    return response;
  },
);

export const getProjectListManager = createAsyncThunk(
  actions.PROJECT_LIST_MANAGER,
  async (payload) => {
    const response = await projectListManager(payload);
    return response;
  },
);

export const fetchEstimate = createAsyncThunk(
  actions.FETCH_ESTIMATE,
  async (payload) => {
    const response = await estimate(payload);
    return response;
  },
);

export const getFinancialYear = createAsyncThunk(
  actions.GET_FINANCIAL_YEAR,
  async (payload) => {
    const response = await financialYear(payload);
    return response;
  },
);

export const getQuarter = createAsyncThunk(
  actions.GET_QUARTER,
  async (payload) => {
    const response = await quarter(payload);
    return response;
  },
);

export const getQuarterManager = createAsyncThunk(
  actions.GET_QUARTER_MANAGER,
  async (payload) => {
    const response = await quarterManager(payload);
    return response;
  },
);

export const quarterlyInputSlice = createSlice({
  name: 'quarterlyInput',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getProjectList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProjectList.fulfilled, (state, action) => {
        state.loading = false;
        state.projectListData = action.payload;
      })
      .addCase(getProjectList.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });

    builder
      .addCase(getFetchQuarterly.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFetchQuarterly.fulfilled, (state, action) => {
        state.loading = false;
        state.quarterlyData = action.payload;
      })
      .addCase(getFetchQuarterly.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });

    builder
      .addCase(createCalculateQuarterly.pending, (state) => {
        state.loading = true;
      })
      .addCase(createCalculateQuarterly.fulfilled, (state, action) => {
        state.loading = false;
        // state.quarterlyData = action.payload;
      })
      .addCase(createCalculateQuarterly.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });

    builder
      .addCase(createSubmitQuarterly.pending, (state) => {
        state.loading = true;
      })
      .addCase(createSubmitQuarterly.fulfilled, (state, action) => {
        state.loading = false;
        // state.quarterlyData = action.payload;
      })
      .addCase(createSubmitQuarterly.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });

    builder
      .addCase(getQuarterlyView.pending, (state) => {
        state.loading = true;
      })
      .addCase(getQuarterlyView.fulfilled, (state, action) => {
        state.loading = false;
        state.quarterlyViewData = action.payload;
      })
      .addCase(getQuarterlyView.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });

    builder
      .addCase(getViewProject.pending, (state) => {
        state.getViewProjectLoading = true;
      })
      .addCase(getViewProject.fulfilled, (state, action) => {
        state.getViewProjectData = action.payload;
        state.getViewProjectLoading = false;
      })
      .addCase(getViewProject.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.getViewProjectLoading = false;
        //message.error(msg);
      });

    builder
      .addCase(getProjectListManager.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProjectListManager.fulfilled, (state, action) => {
        state.loading = false;
        state.projectListManagerData = action.payload;
      })
      .addCase(getProjectListManager.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });

    builder
      .addCase(fetchEstimate.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEstimate.fulfilled, (state, action) => {
        state.loading = false;
        //state.projectListManagerData = action.payload;
      })
      .addCase(fetchEstimate.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });

    builder
      .addCase(getFinancialYear.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFinancialYear.fulfilled, (state, action) => {
        state.loading = false;
        state.financialYear = action.payload;
      })
      .addCase(getFinancialYear.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });

    builder
      .addCase(getQuarter.pending, (state) => {
        state.loading = true;
      })
      .addCase(getQuarter.fulfilled, (state, action) => {
        state.loading = false;
        state.quarter = action.payload;
      })
      .addCase(getQuarter.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });
    builder
      .addCase(getQuarterManager.pending, (state) => {
        state.loading = true;
      })
      .addCase(getQuarterManager.fulfilled, (state, action) => {
        state.loading = false;
        state.quarter = action.payload;
      })
      .addCase(getQuarterManager.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });
  },
});

export default quarterlyInputSlice.reducer;
